'use client';

import { useDateWeather } from '@modules/dashboard/hooks/use_date_weather';
import type { DateWeatherData } from '@modules/dashboard/hooks/use_date_weather';
import { ComponentType } from 'react';

export interface DateWeatherWidgetProps {
  data: DateWeatherData;
  isLoadingWeather: boolean;
}

interface DateWeatherWidgetContainerProps {
  View: ComponentType<DateWeatherWidgetProps>;
}

export function DateWeatherWidgetContainer({ View }: DateWeatherWidgetContainerProps) {
  const { data, isLoadingWeather } = useDateWeather();

  return <View data={data} isLoadingWeather={isLoadingWeather} />;
}
